import { toZonedTime, fromZonedTime } from 'date-fns-tz';
export const zonedTimeToUtc = (date, timeZone) => fromZonedTime(date, timeZone ?? '');
export const utcToZonedTime = (date, timeZone) => toZonedTime(date, timeZone ?? '');
export const setUtcGmtString = (date) => date.toString().replace(/GMT.\d+/, 'GMT+0000');
//# sourceMappingURL=converters.js.map